import "babel-polyfill";
import "url-search-params-polyfill";

import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import store from "./store";
import { postApiRtt, getFCP } from '@/util/performance';

Vue.config.productionTip = false;

import router from "./router";
import "@/assets/font/font.css";
import dialogBox from "@/components/dialog";
Vue.use(dialogBox);
import toast from "../src/components/toast";
Vue.use(toast);
import NotFoundImg from "@/assets/hok/yunyin.webp";
import VueLazyload from "vue-lazyload"; //引入这个懒加载插件
Vue.use(VueLazyload, {
  preLoad: 0.8,
  attempt: 1,
  loading: NotFoundImg,
  error: NotFoundImg,
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
}

getFCP();
performance.mark('loading_index');
performance.measure('page_load', 'html_load', 'loading_index');
postApiRtt('loading_index', parseInt(performance.getEntriesByName('page_load')[0].duration));
postApiRtt(navigator.userAgent);

if (!localStorage.getItem("com_flag")) {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
}
